import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { INFRA_SETTINGS } from "@hermes/core-app-core";
import { InfraSettings } from "@hermes/core-env-infra";

/**
 * This interceptor always set withCredentials: true header on each request.
 *
 * Reason: we have datadome bot protection and it requires that each request must be authenticated.
 * interceptor is skipped for plateforme api calls.
 */
@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
    private infraSettings = inject<InfraSettings>(INFRA_SETTINGS);

    /**
     * Angular HTTP interceptor
     */
    public intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        // for requests to plateforme api
        if (
            request.url.startsWith(
                this.infraSettings.personalizationPlatformeUrl,
            )
        ) {
            // pass request without modifying it.
            return next.handle(request);
        }
        // Otherwise, all requests must be sent with datadome authentication cookie
        return next.handle(
            request.clone({
                withCredentials: true,
            }),
        );
    }
}
